import {Injectable, OnDestroy} from '@angular/core';
import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {FormDefinitionFormModel} from '../../api/entity/formDefinitionForm.model';
import {FormDefinitionFormSummaryModel} from '../../api/entity/formDefinitionFormSummary.model';
import {FormDefinitionFormSummaryDataServiceAdapter} from './ngrx/formDefinitionFormSummaryDataService.adapter';
import {FormDefinitionFormRepository} from './ngrx/formDefinitionForm.repository';

@Injectable()
export class FormDefinitionFormSummaryFindAllService
    extends AbstractFindAllService<FormDefinitionFormModel, FormDefinitionFormSummaryModel>
    implements OnDestroy{

    constructor(repository: FormDefinitionFormRepository, dataServiceAdapter: FormDefinitionFormSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
